export default __webpack_public_path__ + "static/Milo-2cf746d847925697073d763f3b0833288da55972c91a7a04465d267936359bc6.svg";